

import { FileRule, BID_REQUEST_STATUS_ENUM } from "interfaces";
import { getTotalDocumentsCount, fileExistsInObject } from "utils";
import { getFileRules } from "./fileRules";

interface IProps {
  bidData: {
    status: string;
    type: string;
    documents: Record<string, any[]>;
    additionalDocuments: Record<string, any[]>;
    reports: any[];
  };
  user: {
    roles: {
      isOperator: boolean;
      isCustomer: boolean;
      isProvider: boolean;
      isLPRiskManager?: boolean;
      isSeniorCustomer: boolean;
      isSeniorOperator: boolean;
      isRiskManager: boolean;
    };
  };
}

interface BidFilesBlockProps {
  totalDocumentsCount: number;
  showReports: boolean;
  showAdditionalDocs: boolean;
  fileRules: FileRule[];
}

export const getBidFilesBlockProps = ({ bidData, user }: IProps): BidFilesBlockProps => {
  const { status, type, documents, additionalDocuments, reports } = bidData;
  const { isOperator, isCustomer, isProvider, isLPRiskManager, isSeniorCustomer, isSeniorOperator, isRiskManager } =
    user.roles;
  const isAnyOperator = isOperator;
  const isProviderOrLPRiskManager = isProvider || isLPRiskManager;

  const showAdditionalDocs = isOperator || isCustomer;
  const showReports =
    status === BID_REQUEST_STATUS_ENUM.COMPLETED &&
    (isOperator || isRiskManager) &&
    reports?.length > 0 &&
    !!(reports[0] || reports[1]);

  const fileRules = getFileRules({
    status,
    type,
    documents,
    isAnyOperator,
    isCustomer,
    isProvider: isProviderOrLPRiskManager || false,
    isOperator,
    isSeniorCustomer,
    isSeniorOperator,
  });

  // Calculate document count
  const visibleDocuments: Record<string, any[]> = {};
  fileRules.forEach(({ type, visible }) => {
    if (visible && fileExistsInObject(documents, type)) {
      visibleDocuments[type] = documents[type];
    }
  });

  const visibleAdditionalDocuments = showAdditionalDocs ? additionalDocuments : {};
  const visibleReports = showReports ? reports : [];
  const totalDocumentsCount = getTotalDocumentsCount(visibleDocuments, visibleAdditionalDocuments, visibleReports);

  return {
    totalDocumentsCount,
    showReports,
    showAdditionalDocs,
    fileRules,
  };
};
